import React from 'react';
import { View, Text } from 'react-native';

import HeaderDefault from '../../components/HeaderDefault';
import Button from '../../components/Button';

import styles from './styles';

const ConfirmSell = () => {
    return (
        <>
            <HeaderDefault title={"Confirmar"} />

            <View style={styles.container}>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Moeda:</Text>
                    <Text>GPX Token</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor do dia:</Text>
                    <Text>XX,XXX.XXGPX</Text>
                </View>
                <View style={styles.contentPrices}>
                    <Text style={styles.infoPrice}>Valor de venda:</Text>
                    <Text>XX.XXX,00BRL</Text>
                </View>
            </View>

            <Button route={"ConfirmPassword"} text={"CONFIRMAR"} />
        </>
    );
}

export default ConfirmSell;